/**
 * Route for `date-range-timezone-picker`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DateRangeTimezonePickerPage } from "../features/date-range-timezone-picker/DateRangeTimezonePickerPage";

export const dateRangeTimezonePickerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/date-range-timezone-picker",
	component: DateRangeTimezonePickerPage,
});

export default dateRangeTimezonePickerRoute;
